import { render } from "./CreationView.vue?vue&type=template&id=61516e40&scoped=true"
import script from "./CreationView.vue?vue&type=script&lang=js"
export * from "./CreationView.vue?vue&type=script&lang=js"

import "./CreationView.vue?vue&type=style&index=0&id=61516e40&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61516e40"]])

export default __exports__